import { createSlice } from "@reduxjs/toolkit"
import { DropdownObj } from "../Common/commonTypes"

export type SitesFilters = {
    site: string
    pincode: string
}

export type SitesInternalFilters = {
    state: DropdownObj[]
    city: DropdownObj[]
    status: DropdownObj
    siteType: DropdownObj
    addedBy: DropdownObj[]
    tags: DropdownObj[]
    country_id: DropdownObj
}

type InitialState = {
    filterValues: SitesFilters & SitesInternalFilters
    internalFilterValues: SitesInternalFilters
    page: number
    numOfRows: number
    historyPage: number
    historySelectedValue: number
    visibleColumns: { name: string; visible: boolean }[]
}

const initialState: InitialState = {
    filterValues: {
        site: "",
        pincode: "",
        state: [],
        city: [],
        status: {} as DropdownObj,
        siteType: {} as DropdownObj,
        country_id: {} as DropdownObj,
        addedBy: [],
        tags: [],
    },
    // this stores the values for the filters present in the side drawer
    internalFilterValues: {
        state: [],
        city: [],
        status: {} as DropdownObj,
        siteType: {} as DropdownObj,
        addedBy: [],
        country_id: {} as DropdownObj,
        tags: [],
    },
    page: 1,
    numOfRows: 10,
    historyPage: 1,
    historySelectedValue: 10,
    visibleColumns: [
        { name: "CSMS ID", visible: false },
        { name: "Added On", visible: false },
        { name: "Added By", visible: false },
    ],
}

const SiteSlice = createSlice({
    name: "sites",
    initialState,
    reducers: {
        setPage: (state, action) => {
            state.page = action.payload
        },
        setNumOfRows: (state, action) => {
            state.numOfRows = action.payload
        },
        setHistoryPage: (state, action) => {
            state.historyPage = action.payload
        },
        setHistorySelectedValue: (state, action) => {
            state.historySelectedValue = action.payload
        },
        setSitesFilters: (state, action) => {
            state.filterValues = action.payload
        },
        setInternalSitesFilters: (state, action) => {
            state.internalFilterValues = action.payload
        },
        setVisibleColumns: (state, action) => {
            state.visibleColumns = action?.payload
        },
    },
})

export const {
    setPage,
    setNumOfRows,
    setSitesFilters,
    setInternalSitesFilters,
    setHistoryPage,
    setVisibleColumns,
    setHistorySelectedValue,
} = SiteSlice.actions
export default SiteSlice.reducer
